import { StringParam, useQueryParam } from "use-query-params";

export const useSelectedBookingId = () => {
  const [selectedBookingId, setSelectedBookingId] = useQueryParam("job", StringParam);
  return [selectedBookingId, setSelectedBookingId] as const;
};
